module.exports = __webpack_public_path__ + "img/stikla_dupla.4e6fc400.svg";